<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备类型：</span>
        </div>
        <el-select v-model="formData.deviceType" size="small" style="width: 280px">
          <el-option v-for="item in deviceTypeList" :key="item.deviceType"
                     :label="item.name" :value="item.deviceType">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备名称：</span>
        </div>
        <el-input v-model="formData.deviceName" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备编号：</span>
        </div>
        <el-input v-model="formData.deviceCode" onkeyup="this.value=this.value.replace(/[\u4E00-\u9FA5]/g,'')" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <!--          <b class="red">*</b>-->
          <span class="line-text">设备厂商：</span>
        </div>
        <el-input v-model="formData.deviceManufacturerName" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <!--          <b class="red">*</b>-->
          <span class="line-text">设备型号：</span>
        </div>
        <el-input v-model="formData.deviceModelName" size="small" style="width: 280px" />
      </div>

<!--      <div class="form-line">-->
<!--        <div class="textBox">-->
<!--          <b class="red">*</b>-->
<!--          <span class="line-text">最小阈值：</span>-->
<!--        </div>-->
<!--        <el-input v-model="formData.thresholdMin" size="small" style="width: 280px" />-->
<!--      </div>-->

<!--      <div class="form-line">-->
<!--        <div class="textBox">-->
<!--          <b class="red">*</b>-->
<!--          <span class="line-text">最大阈值：</span>-->
<!--        </div>-->
<!--        <el-input v-model="formData.thresholdMax" size="small" style="width: 280px" />-->
<!--      </div>-->

      <div class="form-line">
        <div class="textBox">
          <!--          <b class="red">*</b>-->
          <span class="line-text">所属场所：</span>
        </div>
        <el-select v-model="formData.bindPlaceCode" size="small" style="width: 280px">
          <el-option v-for="item in powerRoomList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <!--          <b class="red">*</b>-->
          <span class="line-text">关联网关：</span>
        </div>
        <el-select v-model="formData.bindGatewayCode" size="small" style="width: 280px">
          <el-option v-for="item in environmentGatewayDeviceList" :key="item.deviceCode"
                     :label="item.deviceName" :value="item.deviceCode">
          </el-option>
        </el-select>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import TextTitle from '../../../components/Text/TextTitle'
import ButtonConfirm from '../../../components/Button/ButtonConfirm'
import ButtonCancel from '../../../components/Button/ButtonCancel'
import {getObjectURL} from '../../../utils/toBase64'
import {bus} from '../../../utils/bus'
import {api} from '../../api/SmartDetection'
import {nError, nSuccess} from '../../../utils/notice'
import {errorHandler} from '../../../utils/errorHandler'

export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb},
  name: 'smart-detection-probe-add',
  data () {
    return {
      breadcrumb: [{
        value: '配电监测',
        name: 'smart-detection-over-view'
      }, {
        value: '传感器管理'
      }],
      mainTitle: '添加传感器',
      subheading: '',

      deviceTypeList: [
        {code: 'B0', name: '水泵设备'},
      ],
      deviceManufacturerList: [
        {code: '大麦物联', name: '大麦物联'}
      ],
      deviceModelNameList: [
        {code: 'DM-IOTC-PD-E', name: 'DM-IOTC-PD-E'},
      ],
      powerRoomList: [],
      environmentGatewayDeviceList: [],
      formData: {
        deviceType: 'B0',
        deviceName: '',
        deviceCode: '',
        upperSite: '',
        runTime: '',
        deviceManufacturerName: '',
        deviceModelName: '',
        svg: '',
        vg: '',
        ir: '',
        rc: '',
        powerRoomCode: '',
        powerRoomName: '',
        energyGatewayDeviceCode: '',
        energyGatewayDeviceName: '',
      },

    }
  },
  created () {
    this.getPowerRoomList()
    this.getEnvironmentGatewayList()
  },
  methods: {
    getPowerRoomList () {
      this.$axios.post(`${api.getPlaceList}`, {})
        .then(res => {
          let list = res.data.data
          this.powerRoomList = list
        })
        .catch(errorHandler('查询场所失败'))
    },

    getEnvironmentGatewayList () {
      this.$axios.post(`${api.getGatewayDeviceList}`, {})
        .then(res => {
          let list = res.data.data
          this.environmentGatewayDeviceList = list
        })
        .catch(errorHandler('查询电压采集网关失败'))
    },

    toManagementPage () {
      this.$router.push({
        name: 'smart-detection-power-distribution-cabinet-manage'
      })
    },

    // 添加
    confirm () {
      if (!this.formData.deviceName) {
        nError('请输入设备名称')
        return false
      }
      if (!this.formData.deviceCode) {
        nError('请输入设备编号')
        return false
      }
      this.powerRoomList.map(v => {
        if (v.code === this.formData.bindPlaceCode) {
          this.formData.bindPlaceName = v.name
        }
      })
      this.environmentGatewayDeviceList.map(v => {
        if (v.deviceCode === this.formData.bindGatewayCode) {
          this.formData.bindGaetwayName = v.deviceName
        }
      })
      this.$axios.post(api.addPumpDetector, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('添加成功')
            this.toManagementPage()
          }
        })
        .catch(errorHandler('添加失败'))
    },

    cancel () {
      this.toManagementPage()
    }
  }
}
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #FF0000;
  vertical-align: sub;
}
.form-line {
  margin: 20px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.form-line>div {
  margin-right: 20px;
}
.line-text{
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 190px;
  line-height: 32px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 110px 0 140px;
  margin: 40px 0 0 0;
  display: flex;
  justify-content: space-between;
}
.newly2 {
  display: inline-block;
  width: 250px;
  height: 173px;
  vertical-align: text-top;
  border: 1px dashed #D7D7D7;
  margin-right: 20px;
  position: relative;
}
.newly2 span {
  display: block;
  width: 100%;
  color: #999999;
  margin: 0;
  padding: 0;
  text-align: center;
}
.newly2 span:first-child {
  font-size: 36px;
  line-height: 120px;
  position: absolute;
  top: 15px;
}
.newly2 span:last-child {
  font-size: 14px;
  line-height: 50px;
  position: absolute;
  bottom: 0;
}
.upload2 {
  display: inline-block;
  width: 250px;
  height: 173px;
  vertical-align: text-top;
  background-size: 100% 100%;
  position: relative;
}

.upload2 img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}
.upload2 b {
  display: inline-block;
  width: 100%;
  line-height: 21px;
  color: white;
  background-color: #989796;
  text-align: center;
  position: absolute;
  bottom: 0;
  opacity: .7;
}
</style>

<style lang="less">
.el-switch {
  height: 30px;
}
</style>




// WEBPACK FOOTER //
// src/view/SmartDetection/SmartDetectionProbe/SmartDetectionProbeAdd3.vue